import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withNavigationErrorHandler} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import {tokenInterceptor} from "./core/interceptors/token.interceptor";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {errorInterceptor} from "./core/interceptors/error.interceptor";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideClientHydration} from "@angular/platform-browser";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {ruPaginatorIntl} from "./core/i18n/ru-paginator-intl";

/**
 * После выкатки админки старые файлы разделов удаляются. Открытая до выкатки вкладка при переходе в раздел
 * просит уже несуществующий файл → «Failed to fetch dynamically imported module» и пустая страница
 * (кураторы 20.10.2026: «ошибки»). Такую ошибку лечим одной перезагрузкой на новый адрес; повтор не чаще
 * раза в минуту, чтобы не зациклиться, если файла нет по другой причине.
 */
export function reloadOnStaleChunk(error: { error?: unknown; url?: string }): void {
  const e = error?.error as { message?: string; name?: string } | undefined;
  const msg = `${e?.name ?? ''} ${e?.message ?? ''}`;
  if (!/Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk/i.test(msg)) return;
  try {
    const last = Number(sessionStorage.getItem('iqra-chunk-reload') ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('iqra-chunk-reload', String(Date.now()));
  } catch { /* sessionStorage недоступен — всё равно перезагружаем */ }
  // Сразу открываем раздел, куда шёл куратор, уже из новой версии админки.
  if (error?.url) window.location.assign(error.url); else window.location.reload();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withNavigationErrorHandler(reloadOnStaleChunk)),
    provideAnimationsAsync(),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor])),
    MatSnackBarModule,
    {provide: MatPaginatorIntl, useFactory: ruPaginatorIntl},
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ]
};
